<template>
  <BaseImage
    v-bind="$attrs"
    v-on="$listeners"
    :href="href"
    :openInCurrentTab="true"
    :src="src"
    :styleConfig="styleConfig"
  />
</template>

<script>
  import BaseImage from '@base/v2/base-image'
  import { IMAGE_FILES } from '@js/constants'

  const path = require('path');

  export default {
    name: 'LogoImagePrimary',
    inheritAttrs: false,
    components: {
      BaseImage,
    },
    props: {
      useWordmark: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: function () {
      return {
        //src: null,
        styleConfig: {
          container: {
            overflow: 'none',
            height: '100%',
            width: '100%',
          },
          image: {
            cursor: {
              '': 'pointer',
              disabled: 'default',
            },
            maxWidth: '100%',
            minWidth: '100%',
            objectFit: 'contain',
          },
        },
      };
    },
    /*created: function () {
      this.src = require(`@img/${this.logoImageFile}`);
    },*/
    computed: {
      href: function () {
        return `${path.join(process.env.BASE_URL)}`;
      },
      logoImageFile: function () {
        return this.useWordmark
          ? IMAGE_FILES.LOGO.SECONDARY
          : IMAGE_FILES.LOGO.PRIMARY;
      },
      src: function () {
        return require(`@img/${this.logoImageFile}`);
      },
    }
  };
</script>
